























import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import { TimeOffTemplateFieldError } from '@/models';

export default Vue.extend({
  name: 'TimeOffTemplatePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    label: {
      type: String,
      default: 'TimeOffTemplates'
    },

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | TimeOffTemplateFieldError>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      timeOffTemplates: 'timeOff/getTimeOffTemplates'
    }),

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];

      if (!(this.externalErrorMessage instanceof TimeOffTemplateFieldError)) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    // fetch all timeOffTemplates
    this.loading = true;

    this.fetchTimeOffTemplates()
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => (this.loading = false));
  },

  methods: {
    ...mapActions({
      fetchTimeOffTemplates: 'timeOff/fetchTimeOffTemplates'
    })
  }
});
